module.exports = __webpack_public_path__ + "static/media/008iOS - 8 - MY HEALTH.e431292e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/008iOS - 8 - MY HEALTH.png
// module id = 505
// module chunks = 0